// extracted by mini-css-extract-plugin
module.exports = {"container":"dormant-modal-container__3fUUU","link":"dormant-modal-link__1284Y","warning":"dormant-modal-warning__2QUO3"};